import { cn } from '@/shared/utils/helpers/cn'

type BadgeColor = 'indigo' | 'green' | 'amber' | 'red' | 'blue'

const badgeStyles: Record<BadgeColor, string> = {
  indigo: 'bg-blue-500/15 text-blue-400',
  green: 'bg-emerald-500/15 text-emerald-400',
  amber: 'bg-amber-500/15 text-amber-400',
  red: 'bg-red-500/15 text-red-400',
  blue: 'bg-blue-500/15 text-blue-400',
}

interface CountBadgeProps {
  count: number | string
  color?: BadgeColor
  className?: string
}

export function CountBadge({ count, color = 'indigo', className }: CountBadgeProps) {
  return (
    <span className={cn('text-[8px] px-1.5 py-0.5 rounded font-medium', badgeStyles[color], className)}>
      {count}
    </span>
  )
}
